/* Mavras Köken bölümleri – kaydırınca belirme ve adım kaydırıcısı */
(function () {
  if (window.MavrasOrigins) return;
  document.documentElement.classList.add('mo-js');

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-mo-reveal]').forEach(function (el) {
      if (observer && !window.Shopify?.designMode) observer.observe(el);
      else el.classList.add('is-visible');
    });
  }

  function initSteps(root) {
    root.querySelectorAll('[data-mo-steps]').forEach(function (section) {
      if (section.dataset.moReady) return;
      section.dataset.moReady = 'true';
      var track = section.querySelector('[data-mo-track]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-mo-slide]'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-mo-dot]'));
      if (!track || slides.length === 0) return;

      var current = 0;
      function goTo(index) {
        current = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
      }
      function update() {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        current = Math.max(0, Math.min(slides.length - 1, index));
        dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      }

      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
      var prev = section.querySelector('[data-mo-prev]');
      var next = section.querySelector('[data-mo-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });

      var delay = parseInt(section.dataset.moAutoplay, 10);
      if (delay > 0 && slides.length > 1 && !window.Shopify?.designMode) {
        var timer = setInterval(function () { goTo(current + 1); }, delay * 1000);
        section.addEventListener('mouseenter', function () { clearInterval(timer); });
        section.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
      }

      section.addEventListener('shopify:block:select', function (event) {
        var i = slides.indexOf(event.target);
        if (i > -1) goTo(i);
      });
      update();
    });
  }

  function init(root) { initReveal(root); initSteps(root); }

  window.MavrasOrigins = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
